// TODO: create autoimport method
import { default as user } from './IconUser.vue';
import { default as eyeHide } from './IconEyeHide.vue';
import { default as eyeShow } from './IconEyeShow.vue';
import { default as lock } from './IconLock.vue';
import { default as email } from './IconEmail.vue';
import { default as mobileApp } from './IconMobileApp.vue';
import { default as site } from './IconSite.vue';
import { default as company } from './IconCompany.vue';
import { default as selectDown } from './IconSelectDown.vue';
import { default as maintence } from './IconMaintence.vue';
import { default as more } from './IconMore.vue';
import { default as warning } from './IconWarning.vue';
import { default as person } from './IconPerson.vue';
import { default as externalLink } from './IconExternalLink.vue';
import { default as selectUp } from './IconSelectUp.vue';
import { default as search } from './IconSearch.vue';
import { default as labTest } from './IconLabTest.vue';
import { default as blog } from './IconBlog.vue';
import { default as image } from './IconImage.vue';
import { default as close } from './IconClose.vue';
import { default as errorCircle } from './IconErrorCircle.vue';
import { default as successCircle } from './IconSuccessCircle.vue';
import { default as goBack } from './IconGoBack.vue';
import { default as dev } from './IconDev.vue';
import { default as unlock } from './IconUnlock.vue';
import { default as rocket } from './IconRocket.vue';
import { default as apps } from './IconApps.vue';
import { default as copy } from './IconCopy.vue';
import { default as info } from './IconInfo.vue';
import { default as question } from './IconQuestion.vue';
import { default as successSolid } from './IconSuccessSolid.vue';
import { default as goAhead } from './IconGoAhead.vue';
import { default as clockTime } from './IconClockTime.vue';
import { default as errorSolid } from './IconErrorSolid.vue';
import { default as calendar } from './IconCalendar.vue';

export default {
    company,
    email,
    lock,
    'eye-hide': eyeHide,
    'eye-show': eyeShow,
    'mobile-app': mobileApp,
    'select-down': selectDown,
    'select-up': selectUp,
    site,
    user,
    maintence,
    more,
    warning,
    person,
    'external-link': externalLink,
    search,
    'lab-test': labTest,
    blog,
    image,
    close,
    'error-circle': errorCircle,
    'success-circle': successCircle,
    'go-back': goBack,
    'go-ahead': goAhead,
    dev,
    unlock,
    rocket,
    apps,
    copy,
    info,
    question,
    'success-solid': successSolid,
    'clock-time': clockTime,
    'error-solid': errorSolid,
    calendar,
};
